<button *ngIf="isPrimaryOrg" [disabled]="!emailConfirmed && !isActivated && isDenied" (click)="impersonate()" [disabled]="disabled" uiLibButton
            [color]="'PRIMARY' | buttonColorEnumPipe"
            [size]="'SMALL' | buttonSizeEnumPipe"
            [shape]="'ROUNDED' | buttonShapeEnumPipe"
            [style]="'OUTLINED' | buttonStyleEnumPipe">
      Impersonate
    </button>
  
